var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shimmer-table-loader"},_vm._l((_vm.rowCount),function(row){return _c('div',{key:row,staticClass:"shimmer-row"},_vm._l((_vm.columnCount),function(column){return _c('div',{key:column,staticClass:"shimmer-cell"})}),0)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }